//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      isShow: true,
    };
  },
  computed: {
    ad() {
      return this.$store.state.advertisement;
    },
  },
};
